import { ConnectorsErrorCode } from '../../types/services/connectors-error';
import { Aggregator } from '../../types/services/enums';
export class ConnectorsError extends Error {
    constructor(code, details) {
        const defaultMessage = ConnectorsError.getDefaultMessage(code);
        super(details.message || defaultMessage);
        this.error = Object.assign(Object.assign({ code, connector: details.connector || Aggregator.UNKNOWN }, details), { message: details.message || defaultMessage, error: details.error || '' });
        if (code === ConnectorsErrorCode.GAS_SIMULATION_ERROR) {
            this.error = {
                code,
                connector: Aggregator.UNKNOWN,
                tokenIn: details.to || '',
                tokenOut: details.from || '',
                amountIn: details.value || '',
                message: details.message || defaultMessage,
                error: details.error || '',
            };
        }
    }
    static getDefaultMessage(code) {
        switch (code) {
            case ConnectorsErrorCode.PRICE_NOT_FOUND:
                return 'Price not found.';
            case ConnectorsErrorCode.QUOTE_NOT_FOUND:
                return 'Quote not found.';
            case ConnectorsErrorCode.GAS_SIMULATION_ERROR:
                return 'Gas simulation error.';
            case ConnectorsErrorCode.UNSUPPORTED_NETWORK:
                return 'Unsupported network.';
            case ConnectorsErrorCode.UNSUPPORTED_AGGREGATOR:
                return 'Unsupported aggregator.';
            case ConnectorsErrorCode.ERC20_METADATA_ERROR:
                return 'ERC20 metadata error.';
            case ConnectorsErrorCode.PRICE_IMPACT_TOO_HIGH:
                return 'Price impact too high.';
            case ConnectorsErrorCode.GENERIC_ERROR:
                return 'An unknown error occurred.';
            case ConnectorsErrorCode.REVERSAL_IS_IMPOSSIBLE:
                return 'Reversal is impossible because a price or quote failed.';
            case ConnectorsErrorCode.SPONSOR_SIMULATION_ERROR:
                return 'Sponsor simulation error.';
            case ConnectorsErrorCode.INTERMEDIARY_TOKEN_NOT_FOUND:
                return 'Intermediary token is required for this step, and it was not found';
            case ConnectorsErrorCode.WORMHOLE_TOKEN_NOT_FOUND:
                return 'Wormhole token for given intermediary token not found.';
            case ConnectorsErrorCode.AMOUNT_REQUESTED_TOO_LOW:
                return 'The amount requested is too low to cover the fee and any native gas requested.';
            default:
                return 'An unknown error occurred.';
        }
    }
    static createInsufficientBalanceError(network, owner, token, requestedAmount, actualBalance) {
        return new ConnectorsError(ConnectorsErrorCode.INSUFFICIENT_BALANCE, {
            owner,
            tokenIn: token,
            amountIn: requestedAmount,
            balance: actualBalance,
            message: `Insufficient balance. Requested: ${requestedAmount}, Available: ${actualBalance}`,
        });
    }
    static createSimulationError(error, details) {
        return new ConnectorsError(ConnectorsErrorCode.SIMULATION_ERROR, {
            to: details.to,
            from: details.from,
            value: details.value,
            message: details.message || 'Simulation error.',
            error,
        });
    }
}
